import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, timeout } from 'rxjs';
import { environment } from '../../environments/environment';
import { BBResponseContainer } from '../carrier/response-container';
import { CreateNewArraysDTO, PlateUpdateDTO, ReportingFileNameDTO, SingleSamplesRedoDTO } from './model/ma-result-evaluation-dtos';
import { SingleRedoMultiPlateRequestDTO } from './model/upload-single-redo-file-response-dto';


@Injectable({
  providedIn: 'root'
})
export class  MaResultEvaluationService {
  RESULT_EVALUATION_API = environment.BB_RESULT_EVALUATION_URL

  constructor(private httpClient: HttpClient) { }

  fetchArray(plateID: string,labId:string): Observable<BBResponseContainer>{
    let url = this.RESULT_EVALUATION_API+'array/'+labId+"/"+plateID;
    return this.httpClient.get<BBResponseContainer>(url);
  }

  fetchArrayBySample(sample_id: string, labId:string): Observable<BBResponseContainer>{
    let url = this.RESULT_EVALUATION_API+'array/sampleSearch/'+labId+"/"+sample_id;
    return this.httpClient.get<BBResponseContainer>(url);
  }


  fetchArrays(labId:string, status?: string, processFlowName?: string, fromDate?: Date): Observable<any[]>{
    let url = this.RESULT_EVALUATION_API+'array/list/'+labId+'?';
    if (typeof status !== 'undefined') {
      url = url + "selectedStatusList="+status;
    }
    else{
      url = url + "selectedStatusList=";
    }
    if (typeof processFlowName !== 'undefined') {
      url = url + '&selectedProcessFlowNameList='+processFlowName;
    }else{
      url = url + '&selectedProcessFlowNameList=';
    }
    if (fromDate !== undefined && fromDate!==null) {
      url = url + '&fromDate='+fromDate.toDateString();
    }
    else{
      url = url + '&fromDate=';
    }
    return this.httpClient.get<any[]>(url);
  }

  uploadArrayOutputFile(formData: FormData) {
    let url = this.RESULT_EVALUATION_API + "array/upload/output";
    return this.httpClient.post<any>(url, formData)
  }

  updateReportingFileName(data: ReportingFileNameDTO) {
    let url = this.RESULT_EVALUATION_API + "array/updateReportingFileName";
    return this.httpClient.put<BBResponseContainer>(url, data)
  }

  createArrayFromSamplesData(data: CreateNewArraysDTO){
    let url = this.RESULT_EVALUATION_API + "array/create";
    return this.httpClient.put<any>(url, data)
  }

  completeAnalysis(plateUpdateDTO: PlateUpdateDTO){
    let url = this.RESULT_EVALUATION_API + "array/completeAnalysis";
    return this.httpClient.put<any>(url, plateUpdateDTO)
  }

  updateArrayStatus(plateUpdateDTO: PlateUpdateDTO){
    const url = this.RESULT_EVALUATION_API + "array/updateArray";
    return this.httpClient.put<any>(url, plateUpdateDTO).pipe(timeout(environment.defaultTimeout))
  }

  updateSingleRedoSamples(data: SingleSamplesRedoDTO) {
    let url = this.RESULT_EVALUATION_API + "array/singleRedo";
    return this.httpClient.put<BBResponseContainer>(url, data)
  }

  uploadSingleRedoFile(formData: FormData): Observable<BBResponseContainer> {
    let url = this.RESULT_EVALUATION_API + "array/singleRedo/upload";
    return this.httpClient.post<BBResponseContainer>(url, formData)
  }

  updateMultiPlateSingleRedoSamples(data: SingleRedoMultiPlateRequestDTO) {
    let url = this.RESULT_EVALUATION_API + "array/singleRedo/multiplate";
    return this.httpClient.put<BBResponseContainer>(url, data)
  }

  updatePlateRedo(labId: string, plateId: string, sourcePlate: any) {
    let url = this.RESULT_EVALUATION_API + `array/plateRedo/${labId}/${plateId}`;
    return this.httpClient.put<BBResponseContainer>(url, sourcePlate)
  }
  
}
